import { InteractiveTable, ActionPanel as LuterkortActionPanel } from '@ingrid/luterkort-react';

import { RoleGuard } from '~src/components/RoleGuard/RoleGuard';
import { useTranslation } from '~src/i18n/use-translation';
import { useToast } from '~src/main/hooks/useToast';

import { useCarrierContractRemoveMutation } from '../mutations';

export function ActionPanel() {
  const { selectionManager } = InteractiveTable.useContext();
  const { t } = useTranslation();
  const { toast } = useToast();

  const removeMutation = useCarrierContractRemoveMutation();
  const selected = selectionManager.getSelectedKeys();

  const handleRemoveSelectedContracts = async () => {
    const promise = Promise.all(selected.map(id => removeMutation.mutateAsync(id)));

    await toast.promise(promise, {
      loading: { title: t('carrierContracts.list.removeLoading') },
      error: { title: t('carrierContracts.list.removeError') },
      success: { title: t('carrierContracts.list.removeSuccess') },
    });

    selectionManager.clearAll();
  };

  return (
    <LuterkortActionPanel.Root style={{ width: '100%', maxWidth: '1008px' }}>
      <LuterkortActionPanel.Selection />

      <LuterkortActionPanel.Inline>
        <LuterkortActionPanel.DeselectAllButton />
      </LuterkortActionPanel.Inline>

      <LuterkortActionPanel.Actions>
        <RoleGuard roles={['transport:edit']} withTooltip>
          <LuterkortActionPanel.LoadingButton
            loading={removeMutation.isPending}
            onClick={handleRemoveSelectedContracts}
          >
            {t('common.delete')}
          </LuterkortActionPanel.LoadingButton>
        </RoleGuard>
      </LuterkortActionPanel.Actions>
    </LuterkortActionPanel.Root>
  );
}
